<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body customHeight">
            <!-- <TableHeader :isActive="true" searchVisible url="teamtask/table" :changeGrid="true" actionClass="d-flex align-items-center justify-content-between" /> -->
            <TableHeader
              :changeGrid="true"
              :isActive="true"
              searchVisible
              bottomTitle
              actionClass="d-flex align-items-end justify-content-between"
              :notDropdown="true"
              :tableId="tableId"
              @tableObj="updateBoard($event)"
              url="teamtask/table"
            />
            <div>
              <div class="drag-list cols-container">
                <div class="tasks-column" v-for="cols in kanbanData.boardColumns" :key="cols.id">
                  <div class="card main-kan-col">
                    <div class="board-body">
                      <span class="drag-column-header">
                        <h4 class="card-title mb-4 pb-1 d-flex align-items-center" :key="issueHeaderKey">
                          <span class="column-header-text">{{ cols.name }}</span>
                          <span class="column-header-count">{{ cols.issueCount }}</span>
                        </h4>
                      </span>
                      <draggable
                        :key="draggableKey"
                        class="col-height"
                        :class="cols.id.toString()"
                        group="tasks"
                        @change="log"
                        v-model="cols.issues"
                        @end="logend"
                        v-bind="dragOptions"
                      >
                        <div v-for="task in cols.issues" :key="task.id" :accessKey="task.id" class="card task-box" @click="$router.push({ path: `/teamtask/${$route.params.slug}/details/${task.id}` })">
                          <div class="board-cards-body">
                            <div class="d-flex">
                              <div class="card-main-content">
                                <div>
                                  <h5 class="font-size-13 font-weight-bold">
                                    <a href="javascript: void(0);" class="text-dark d-flex justify-content-between align-items-center">
                                      <!-- <img src="@/assets/images/teamtask/priority-level.svg" alt="" class="d-block" style="margin-left: 10px !important;" /> -->

                                      <div class="rightTitle d-flex align-items-center">
                                        <i :class="`${setPriority(parseInt(task.priority))} me-2`"></i>
                                        <span>{{ task.rightTitle }}</span>
                                      </div>

                                      <span>{{ task.leftTitle }}</span>
                                    </a>
                                  </h5>
                                  <div class="font-size-13">
                                    {{ task.description }}
                                  </div>
                                </div>
                                <div class="mt-2 mb-2">
                                  <!-- <span
                                    class="badge rounded-pill font-size-12"
                                    :class="task.status.color"
                                    >{{ task.status.text }}</span
                                  > -->
                                  <Status v-if="task.status.text" :color="task.status.color" :status="task.status" />
                                  <!-- 'badge-soft-secondary': `${task.taskType}` === 'در انتظار',
                                      'badge-soft-success': `${task.taskType}` === 'کامل',
                                      'badge-soft-primary': `${task.taskType}` === 'Approved',
                                      'badge-soft-warning': `${task.taskType}` === 'ردشده', -->
                                  <!-- bala ro rangesho amir mide  -->
                                </div>
                              </div>
                              <div class="priority-container">
                                <div
                                  v-for="color in getColors(task.bulletCount)"
                                  :key="color.color"
                                  class="priority-bullet"
                                  :style="{
                                    background: color.color,
                                  }"
                                ></div>
                              </div>
                            </div>
                            <hr class="mt-1 mb-2" />
                            <!-- <p class="text-muted mb-4">{{ task.date }}</p> -->
                            <div class="task-card-footer">
                              <div>
                                <span class="avatar-group-item">
                                  <a href="javascript: void(0);" class="d-inline-block">
                                    <img v-if="task.userImage !== null && task.userImage !== ''" :src="`${task.userImage}`" class="rounded-circle task-avatar" alt="avatar" />
                                    <img v-else src="@/assets/images/users/default.png" class="rounded-circle task-avatar" alt="avatar" />
                                  </a>
                                </span>
                                <span class="time-container">
                                  <img src="@/assets/images/teamtask/clock-logo.svg" alt="" class="clock-logo" />
                                  {{ TellMeWhen(task.createdDate) }}
                                </span>
                              </div>
                              <div>{{ task.footer }}</div>
                            </div>
                          </div>
                        </div>
                        <!-- <div @click="getMoreData">load more tasks</div> -->
                      </draggable>
                    </div>
                  </div>
                </div>
                <!-- end col-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
import TableHeader from '../common/table/simpleTable/TableHeader'
import Status from '../common/Status.vue'
import { kanbanMixins } from '../../utils/mixins'
import kanabanBoarDataProvider from '@/services/kanabanBoard'
export default {
  mixins: [kanbanMixins],
  components: {
    draggable,
    TableHeader,
    Status,
  },
  data() {
    return {
      temp: null,
      draggableKey: 1,
      issueHeaderKey: 0,
      boardPagination: {
        query: '',
        key: this.$route.params.slug,
        pageNumber: 1,
        pageSize: 500,
      },
    }
  },
  computed: {
    dragOptions() {
      return {
        animation: 300,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost',
      }
    },
  },
  methods: {
    setPriority(payload) {
      switch (payload) {
        case -2:
          return 'fa-regular fa-chevrons-down downChevron'
        case -1:
          return 'fa-regular fa-chevron-down downChevron'
        case 0:
          return 'fa-regular fa-minus minusPriority'
        case 1:
          return 'fa-regular fa-chevron-up upChevron'
        case 2:
          return 'fa-regular fa-chevrons-up upChevron'
      }
    },
    normalClassName(payload) {
      return payload.replace('col-height ', '')
    },
    log: function (evt) {
      // this.temp = {
      //   issueId: null,
      //   from: null,
      //   to: null,
      //   index: null,
      //   // issueId: evt.added.element.id,
      //   // from: evt.removed.element.boardColumnId,
      //   // to: evt.added.element.boardColumnId,
      //   // index: evt.added.newIndex,
      // }
      // setTimeout(() => {
      // if (evt.added) {
      //   // console.log('added', evt.added)
      //   this.temp.issueId = evt.added.element.id
      //   this.temp.to = evt.added.element.boardColumnId
      //   this.temp.index = evt.added.newIndex
      // }
      // if (evt.removed) {
      //   this.temp.from= evt.removed.element.boardColumnId
      // console.log('removed', evt.removed)
      // if (evt.moved) {
      //   console.log('moved', evt.moved)
      // }
      // }, 100)
      // setTimeout(() => {
      //   // console.log(this.temp)
      // }, 1000);
    },
    logend: function (evt) {
      // console.log(parseInt(this.normalClassName(evt.from.className)), parseInt(this.normalClassName(evt.to.className)))
      this.temp = {
        from: parseInt(this.normalClassName(evt.from.className)),
        to: parseInt(this.normalClassName(evt.to.className)),
        issueId: evt.item.accessKey,
        index: evt.newIndex,
      }
      this.updateBoardIssue(this.temp)
    },
    updateBoardIssue(data) {
      kanabanBoarDataProvider
        .updateBoard(data)
        .then((res) => {
          this.temp = null
          this.getKanbanData(this.boardPagination)
        })
        .catch((err) => {
          this.getKanbanData(this.boardPagination)
        })
    },
    updateBoard(payload) {
      let temp = {
        query: payload.query,
        key: this.$route.params.slug,
        pageNumber: 1,
        pageSize: 500,
      }
      this.getKanbanData(temp)
    },
    getKanbanData(payload) {
      kanabanBoarDataProvider
        .getKanbanData(payload)
        .then((res) => {
          this.$store.dispatch('kanban/setKanbanData', res.data.data)
          setTimeout(() => {
            this.draggableKey += 1
          }, 250);
        })
        .catch((err) => {
          console.log('kanban we have an error message : ', err)
        })
    },
    // getMoreData() {
    //   this.$emit('getMoreData')
    // },
  },
}
</script>
<style scoped lang="scss">
.upChevron {
  color: #ff4861;
}
.downChevron {
  color: #70bbfd;
}
.minusPriority {
  color: rgb(255, 171, 0);
}
.upChevron::before,
.downChevron::before {
  font-size: 16px;
}
.main-kan-col {
  background-color: #f8f8f8;
}
.description {
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 25px;
  text-align: right;
  color: #999999;
  margin-bottom: 26px;
}
.column-header-text {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  text-transform: uppercase;
  color: #444444;
}
.column-header-count {
  background-color: #e7e7e7;
  padding: 6px;
  border-radius: 50%;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  text-transform: uppercase;
  color: #444444;
  width: 25px;
  height: 25px;
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.task-avatar {
  height: 23px;
  width: 23px;
}
.task-card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.time-container {
  margin-right: 10px;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  text-align: right;
  color: #a6a6a6;
}
.clock-logo {
  margin-left: 4px;
}
.wrapper {
  display: table-cell;
  vertical-align: bottom;
  height: 200px;
}
.content {
  max-height: 200px;
  overflow: auto;
}
.priority-container {
  transform: rotate(180deg);
  margin-bottom: 10px;
  margin-right: 4px;
}
.priority-bullet {
  height: 3px;
  width: 2px;
  margin-top: 1px;
}
.card-main-content {
  flex: 2;
}
.tasks-column {
  min-width: 285px;
  width: 100%;
  margin-left: 15px;
}
.tasks-column:last-child {
  margin-left: 0px;
}
.cols-container {
  display: flex !important;
  justify-content: space-between !important;
  overflow-x: auto;
}
.board-cards-body {
  padding: 10px 15px;
}
.board-body {
  padding: 20px 15px 0;
  min-height: calc(100vh - 250px);
}
.col-height {
  // max-height: calc(100vh - 470px);
  height: calc(100vh - 320px);
  overflow-y: scroll;
}
.task-box {
  margin-bottom: 15px !important;
}
.customHeight {
  height: calc(100vh - 145px);
}
::-webkit-scrollbar {
  // width: 5px;
  display: none;
}
</style>
